module.exports = "/static/media/Zoho.fc8c7e61.svg";